import { Tooltip } from '@fluentui/react-components';
import { RequestIcon } from '../widgets/RequestsWidget/RequestIcon';
import { CurrentUserVaccation } from './styles/TeamVacationCircle.styled';
import { VACATION_TYPE_LENGTH } from 'src/tabs/constants/Timeoff.constants';

interface CurrentUserVacationProps {
  currentUser: {
    name: string;
    target: Element;
    date: string;
    status: string;
    vacationType: string;
  };
  vacationType: string;
  isOnlyCurrentUserOnVacation: boolean;
}

export const CurrentUserVacationInformation = ({
  currentUser,
  vacationType,
  isOnlyCurrentUserOnVacation,
}: CurrentUserVacationProps) => {
  if (currentUser.vacationType.length > VACATION_TYPE_LENGTH) {
    return (
      <>
        <Tooltip
          content={currentUser.vacationType.replace('Time-off', 'Time off')}
          relationship="description"
        >
          <CurrentUserVaccation
            isOnlyCurrentUserOnVacation={isOnlyCurrentUserOnVacation}
          >
            <RequestIcon requestStatus={currentUser.status} />
            &nbsp; {vacationType}
          </CurrentUserVaccation>
        </Tooltip>
      </>
    );
  } else {
    return (
      <CurrentUserVaccation
        isOnlyCurrentUserOnVacation={isOnlyCurrentUserOnVacation}
      >
        <RequestIcon requestStatus={currentUser.status} />
        &nbsp;{currentUser.vacationType}
      </CurrentUserVaccation>
    );
  }
};
